import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../../context/LanguageContext'
import { getDivisionSectionGroup } from '../../constants/pageSlugs'

export default function DivisionSectionSidebar({ currentSlug }) {
  const { t } = useTranslation()
  const { localized } = useLanguage()
  const group = getDivisionSectionGroup(currentSlug)

  if (!group) return null

  return (
    <aside className="min-w-0 w-full max-w-full space-y-6 lg:sticky lg:top-28 lg:self-start">
      <div className="min-w-0">
        <h3 className="mb-3 text-sm font-bold uppercase tracking-widest text-primary lg:mb-4">
          {t('divisionSidebar.inThisSection')}
        </h3>
        <ul className="flex min-w-0 max-w-full gap-2 overflow-x-auto pb-1 [scrollbar-width:none] lg:block lg:space-y-2 lg:overflow-visible lg:pb-0 [&::-webkit-scrollbar]:hidden">
          {group.items.map((item) => (
            <li key={item.slug} className="shrink-0 lg:shrink">
              <Link
                to={`/pages/${item.slug}`}
                className={`block whitespace-nowrap rounded-lg px-3 py-2.5 text-sm transition-colors lg:whitespace-normal ${
                  currentSlug === item.slug
                    ? 'bg-primary text-white'
                    : 'border border-border/60 bg-white text-text/70 hover:border-primary/25 hover:bg-primary/5 hover:text-primary lg:border-0 lg:bg-transparent'
                }`}
              >
                {localized(item, 'title')}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  )
}
